import classNames from "classnames";
import React from "react";
import { LazyLoadImage } from "../../core/atoms/atoms";

import "./pageImageHeader.scss";

interface IPageImageHeaderProps extends React.Props<PageImageHeader> {
  imageSrc: string;
  imageMeta: string;
  title: string;
  spaceForTabs?: boolean;
}

export class PageImageHeader extends React.Component<IPageImageHeaderProps, {}> {
  public render() {
    return (
      <div className="page-image-header">
        <LazyLoadImage src={this.props.imageSrc} alt={this.props.imageMeta} />
        <div className={classNames("width-wrapper", "overlay", { "space-for-tabs": this.props.spaceForTabs })}>
          <h1 className="text--light">{this.props.title}</h1>
        </div>
      </div>
    )
  }
}